import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import Constants from "../../constants";
import moment from "moment";
import { App } from "@capacitor/app";

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("auth_token");
    console.log(token);

    if (!token || token === "") {
      console.log("Navigate to login");
      navigate("/login");
    } else {
      let constantData = localStorage.getItem("constants"); //getAppConstants();
      let constants = JSON.parse(constantData);
      let tokenTimeout = constants?.tokenTimeout || 30;
      let appCurrentVersion = localStorage.getItem("appCurrentVersion");
      let lastLoggedIn = localStorage.getItem("last_login_time")?.trim();
      lastLoggedIn = lastLoggedIn?.replace(/"/g, "");
      appCurrentVersion = appCurrentVersion?.replace(/"/g, "");

      // console.log("Version Check => ", appCurrentVersion.trim(), Constants.env.version, appCurrentVersion.trim() !== Constants.env.version.toString(), moment(lastLoggedIn).isValid());
      console.log(lastLoggedIn, moment(lastLoggedIn).isValid());
      if (appCurrentVersion !== Constants.env.version) {
        console.log("Not Version");
        localStorage.removeItem("auth_token");
        localStorage.setItem("last_reload_time", "");
        localStorage.setItem("last_login_time", "");
        App.removeAllListeners();
        navigate("/login");
      } else if (moment(lastLoggedIn).isValid()) {
        var currentDate = moment();
        var lastLoggedInDate = moment(lastLoggedIn);
        const difference = currentDate.diff(lastLoggedInDate, "days");
        if (difference < tokenTimeout) {
          if (window.location.href.indexOf("notification") > -1) {
            navigate("/notification");
          } else {
            navigate("/blogs");
          }
        } else {
          localStorage.removeItem("auth_token");
          localStorage.setItem("last_reload_time", "");
          localStorage.setItem("last_login_time", "");
          App.removeAllListeners();
          navigate("/login");
        }
      } else {
        console.log("Not Time");
        localStorage.removeItem("auth_token");
        localStorage.setItem("last_reload_time", "");
        localStorage.setItem("last_login_time", "");
        App.removeAllListeners();
        navigate("/login");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

export default Home;
